import React from 'react'
import Bookslist from '../components/Bookslist'

const Home = () => {
  return (
    <div>
        

        <Bookslist/>
    </div>
  )
}

export default Home